// src/TeamSelection.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const TeamSelection = () => {
  const navigate = useNavigate();
  // Define your teams
  const teams = ['Team 1', 'Team 2', 'Team 3', 'Team 4', 'Team 5'];

  const handleTeamSelect = (team) => {
    // Navigate to a team-specific page, passing the team as a parameter
    navigate(`/team/${team}`);
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h2>Select Your Team</h2>
      {teams.map((team) => (
        <button
          key={team}
          onClick={() => handleTeamSelect(team)}
          style={{ margin: '10px', padding: '10px 20px' }}
        >
          {team}
        </button>
      ))}
    </div>
  );
};

export default TeamSelection;